import { IComponentOptions } from "angular";
import { MachinesWarehouseViewController } from "./controller";

export const vsComponentName = "machinesWarehouseView";

export const MachinesWarehouseViewComponentOptions: IComponentOptions = {
  controller: MachinesWarehouseViewController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machineConfigurations: "<",
  },
};
